import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { media } from "../utils/MediaQueries";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);


function primaryHomeAnimation() {
  
  //const primaryBanner = $('.banner--home');
  //if (!primaryBanner.hasClass('primary-animation')) return;
  
    // Don't allow user to scroll until banner animation is done
    if ( $('body').hasClass('home') ) {
      $('body').addClass('no-scroll');
    }
  
    const homeAnimation = gsap.timeline({
      paused: false,
    });
  
    let imgOneX = -65;
    let imgOneY = -67;
    let imgTwoX = 98;
    let imgTwoY = 63;
    let imgThreeX = -151;
    let imgThreeY = 280;
    let imgThreeRotate = -6;
    let imgThreeAlpha = 0;
    
    let imgOneOriginalY = 68;
    let imgTwoOriginalY = 23;
    let imgThreeOriginalY = 57;
    
    if (window.matchMedia('(max-width: 1200px)').matches){
      imgOneX = -52;
      imgOneY = -45;
      imgTwoX = 68;
      //imgTwoY = 63;
    }
    if (window.matchMedia('(max-width: 992px)').matches){
      imgOneX = -5;
      imgOneY = -52;
      imgTwoX = 68;
      //imgTwoY = 93;
    }
    if (window.matchMedia('(max-width: 850px)').matches){
      imgOneX = -13;
      imgOneY = -52;
      imgTwoX = 140;
      imgTwoY = 93;
      imgThreeX = -131;
      imgThreeY = 192;
      imgThreeRotate = 8;
      imgThreeAlpha = 1;
    }
    if ( window.matchMedia('(max-width: 850px)').matches && window.matchMedia('(min-height: 600px)').matches ){
      imgOneOriginalY = 78;
      imgTwoOriginalY = 50;
      imgThreeOriginalY = 77;
    }
    if (window.matchMedia('(max-width: 767px)').matches){
      imgThreeY = 240;
      imgThreeX = -112;
    }
    if (window.matchMedia('(max-width: 500px)').matches){
      imgOneX = 0;
      imgThreeY = 260;
      imgThreeX = -102;
    }
    if (window.matchMedia('(max-width: 400px)').matches){
      imgOneX = 0;
      imgThreeY = 290;
      imgThreeX = -102;
    }
    if (window.matchMedia('(max-width: 370px)').matches){
      imgOneX = 9;
      imgThreeY = 290;
      imgThreeX = -115;
    }
  
    homeAnimation.delay(1);
  
    homeAnimation.fromTo(
      ".banner--home .floating-images .floating-img--1",
      {
        scale: 5,
        rotate: -10,
        autoAlpha: 0,
      },
      {
        scale: 1,
        rotate: 18,
        autoAlpha: 1,
        xPercent: -55,
        yPercent: imgOneOriginalY,
        duration: 1.2,
        ease: "power2.inOut",
      }
    );
  
    homeAnimation.fromTo(
      ".banner--home .floating-images .floating-img--2",
      {
        scale: 5,
        rotate: 25,
        autoAlpha: 0,
      },
      {
        scale: 1,
        rotate: -14,
        autoAlpha: 1,
        xPercent: -41,
        yPercent: imgTwoOriginalY,
        duration: 1.2,
        ease: "power2.inOut",
      },
      ">+=0.3"
    );
  
    homeAnimation.fromTo(
      ".banner--home .floating-images .floating-img--3",
      {
        scale: 5,
        rotate: 25,
        autoAlpha: 0,
      },
      {
        scale: 1,
        rotate: -6,
        autoAlpha: 1,
        xPercent: -36,
        yPercent: imgThreeOriginalY,
        duration: 1.2,
        ease: "power2.inOut",
      },
      ">+=0.3"
    );
  
    homeAnimation.to(
      ".banner--home .js-fade-out",
      {
        opacity: 0,
        duration: 0.3,
      },
      ">+=0.5"
    );

    
  
    homeAnimation.to(
      ".banner--home .floating-images .floating-img--1",
      {
        xPercent: imgOneX,
        yPercent: imgOneY,
        rotate: -12,
        duration: 1.2,
        ease: "power2.inOut",
      },
      ">"
    );
  
    homeAnimation.to(
      ".banner--home .js-fade-in",
      {
        opacity: 1,
        duration: 0.7,
        ease: "power2.inOut",
      },
      "<"
    );
  
    homeAnimation.to(
      ".banner--home .floating-images .floating-img--2",
      {
        xPercent: imgTwoX,
        yPercent: imgTwoY,
        rotate: 18,
        duration: 1.2,
        ease: "power2.inOut",
      },
      "<"
    );
  
    homeAnimation.to(
      ".banner--home .floating-images .floating-img--3",
      {
        xPercent: imgThreeX,
        yPercent: imgThreeY,
        rotate: imgThreeRotate,
        duration: 1.2,
        ease: "power2.inOut",
      },
      "<"
    );
    homeAnimation.to(
      ".banner--home .floating-images .floating-img--3",
      {
        autoAlpha: imgThreeAlpha,
      },
      ">"
    );
      
    homeAnimation.add(function () {
      $("body").removeClass("no-scroll");
    }, ">");
  
    const moveImagesBanner = gsap.timeline({
      paused: false,
    });
  
    let floatingImgOne = $(".banner--home .floating-img--1");
    let floatingImgTwo = $(".banner--home .floating-img--2");
  
    moveImagesBanner.fromTo(
      floatingImgOne,
      {
        rotate: -12,
      },
      {
        rotate: -6,
        ease: "none",
      }
    );
  
    moveImagesBanner.fromTo(
      floatingImgTwo,
      {
        rotate: 18,
      },
      {
        rotate: 15,
        ease: "none",
      },
      "<"
    );
  
    ScrollTrigger.create({
      trigger: ".banner--home",
      start: "top top",
      end: "bottom top",
      scrub: 0.3,
      animation: moveImagesBanner,
    });
  
}


function homeAnimation() {
  primaryHomeAnimation();
}

export default homeAnimation;
